import React, {useState} from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";
import {PartnerCredential, PartnerCredentialStatus} from "../../Partners/models";
import { PartnerCredentialService } from '../PartnerCredentials.service';

interface UpdatePartnerCredentialStatusConfirmModalProps {
    credential: PartnerCredential;
    nextStatus: PartnerCredentialStatus;
    handleSubmitClose: () => void;
    handleRejectClose: () => void;
}

export function UpdatePartnerCredentialStatusConfirmModal(props: UpdatePartnerCredentialStatusConfirmModalProps) {
    const [saving, setSaving] = useState(false);
    const [savingError, setSavingError] = useState(false);

    const activating = props.nextStatus === PartnerCredentialStatus.ACTIVE;
    const title = activating ? 'Ligipääsu taastamine' : 'Ligipääsu peatamine';
    const actionVerb = activating ? 'taastada' : 'peatada';
    const confirmLabel = activating ? 'Taasta' : 'Peata';
    const loadingLabel = activating ? 'Taastab…' : 'Peatab…';

    const confirmSubmit = async () => {
        setSaving(true);
        setSavingError(false);

        try {
            await PartnerCredentialService.updatePartnerCredentialStatus(props.credential.id, props.nextStatus);
            setTimeout(() => {
                setSaving(false);
                props.handleSubmitClose();
            }, 100);
        } catch (e) {
            console.error('Updating credential status failed', e);
            setSaving(false);
            setSavingError(true);
        }
    };

    return (
        <Modal show={true} centered>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                Kas oled kindel, et soovid ligipääsu{props.credential.name ? ` "${props.credential.name}"` : ''} {actionVerb}?
            </Modal.Body>
            <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                <Button variant="info"
                        onClick={props.handleRejectClose}
                        type="button"
                        disabled={saving}
                        className={"d-flex align-items-center"}>
                    <span className='px-2'>Loobu</span>
                </Button>
                <Button variant={activating ? 'primary' : 'danger'}
                        onClick={confirmSubmit}
                        type="button"
                        disabled={saving}
                        className="d-flex align-items-center">
                    {
                        !saving &&
                        <span className='px-2'>{confirmLabel}</span>
                    }
                    {
                        saving &&
                        <>
                            <span className='px-2'>{loadingLabel}</span>
                            <Spinner size={"sm"} animation={"border"}/>
                        </>
                    }
                </Button>
            </Modal.Footer>
            {
                !saving && savingError &&
                <span className="d-flex justify-content-end text-danger px-2 pb-2">
                    Viga salvestamisel, proovi mõne hetke pärast uuesti.
                </span>
            }
        </Modal>
    );
}
